export default __webpack_public_path__ + "86d0156b013e9655bf0d970ca3b678f8.png";